module.exports = __webpack_public_path__ + "static/media/Georgia Department of Community Affairs template.155f67c0.xlsx";